// extracted by mini-css-extract-plugin
export default {"button":"common_button__rasRh"};